export const ADMIN_PAGE_SIZE = 50;

export const BOOKING_STATUS_FILTERS = [
  { id: "all", label: "All" },
  { id: "active", label: "Active" },
  { id: "completed", label: "Completed" },
  { id: "cancelled", label: "Cancelled" },
];

export const SUPPORT_STATUS_FILTERS = [
  { id: "open", label: "Open" },
  { id: "investigating", label: "Investigating" },
  { id: "resolved", label: "Resolved" },
  { id: "closed", label: "Closed" },
  { id: "all", label: "All" },
];

export const SUPPORT_CATEGORY_LABELS = {
  damage: "Damage",
  payment_refund: "Payment / refund",
  no_show: "No-show",
  fraud: "Fraud",
  other: "Other",
};
